import { Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ILocale} from '../../../../projects/api/src/user/user.model';
import {BehaviorSubject} from 'rxjs';
import {UserApiService} from '../../../../projects/api/src/user/user-api.service';
import {map, switchMap} from 'rxjs/operators';
import {Location, PlatformLocation} from '@angular/common';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';


export class Locale {
  header: string;
  short: string;
  flagURL: string;
  serverShort?: string;
  NavigatorLanguages: string[];
}

@Injectable()
export class LocaleService {
  constructor(
    private location: Location,
    private ngxTranslateService: TranslateService,
    private platformLocation: PlatformLocation,
    private http: HttpClient, private userAPI: UserApiService,
    private localStorageApi: LocalStorageService) {
    this.initService();
  }

  private _locale;

  public calendarOptions = {
    firstDayOfWeek: 1,
    dayNames: ['восскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'день 1', 'день 2'],
    dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'д1', 'д2'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Д1', 'Д2'],
    monthNames: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    monthNamesShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
    today: 'Сегодня',
    clear: 'Очистить'
  };

  public calendarEnOptions = {
    firstDayOfWeek: 1,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'day1', 'day2'],
    dayNamesShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'd1', 'd2'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'd1', 'd2'],
    monthNames: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
    today: 'Today',
    clear: 'Clear'
  };

  private _languages: Locale[] = [
    {
      header: 'English',
      short: 'en_US',
      flagURL: 'assets/static/img/plugins/flag-icon-css/flags/4x3/us.svg',
      serverShort: 'en-US',
      NavigatorLanguages: ['en-US', 'en']
    },
    {
      header: 'Русский',
      short: 'ru',
      flagURL: 'assets/static/img/plugins/flag-icon-css/flags/4x3/ru.svg',
      serverShort: 'ru-RU',
      NavigatorLanguages: ['ru-RU', 'ru']
    },
  ];

  public locale$ = new BehaviorSubject<Locale>(
    this._languages.find(language => {
      const ilocale = this.localStorageApi.load(true, 'ilocale_');
      if (ilocale && language.serverShort === ilocale.replace(/"/g, '')) {
        return true;
      }
      return language.NavigatorLanguages.some(nLang => nLang === window.navigator.language);
    })
    || this._languages[0]
  );

  get languages(): Locale[] {
    return this._languages;
  }

  // Устанавливаем локаль не меняя значения в профиле
  public setCurrentLanguageLocal(locale: Locale) {
        this.localStorageApi.save(true,'ilocale_', JSON.stringify(locale.serverShort));
        this.locale$.next(locale);
  }
  public setCurrentLanguage(locale: Locale) {
    this.userAPI.setProfileLocale(locale.serverShort)
      .subscribe(() => {
        this.setCurrentLanguageLocal(locale);
      });

  }

  public getCalendarLocale(_locale = this._locale) {
    if (_locale === 'ru-RU') {
      return this.calendarOptions;
    }
    return this.calendarEnOptions;
  }

  public setLocale(locale: ILocale) {
    this._locale = locale;
    const language = this._languages.find(_language => _language.serverShort === locale) || Object.assign({}, this.languages[0]);
    this.locale$.next(language);
  }

  private initService() {

    this.locale$.pipe(
      switchMap(locale => {
        console.log('PathName', this.platformLocation.pathname);
        this.localStorageApi.setPathName(this.platformLocation.pathname);
        let path = this.platformLocation.pathname;
        if (path.substring(0, 1) === '/') {
          path = path.replace(/[\/]+/g, '/');
        }

        console.log(`${path}assets/i18n/${locale.short}.json`);
          return this.http.get(`${path}assets/i18n/${locale.short}.json`,
            {headers: new HttpHeaders().set('Cache-Control', 'no-cache')})
            .pipe(map((localeData) => ({localeData: localeData, locale: locale})));
        }
      ),
    ).subscribe(
      (next) => {
        /*TODO: настроить кэширование*/
        this.ngxTranslateService.setTranslation(next.locale.short, next.localeData, true);
        this.ngxTranslateService.use(next.locale.short);
      }
    );
  }

}
